Object.defineProperty(exports, "__esModule", {
  value: true
});

// Customizable Area Start
exports.validationApiContentType = "application/json";
exports.validationApiMethodType = "GET";
exports.exampleAPiEndPoint = "https://jsonplaceholder.typicode.com/todos/1";
exports.exampleAPiMethod = "GET";
exports.exampleApiContentType = "application/json";
exports.textInputPlaceHolder = "Enter Text";
exports.labelTitleText = "ApiIntegration Excample";
exports.labelBodyText = "Click Button to Demo ApiIntegration";
exports.btnExampleTitle = "CLICK ME";
// Customizable Area End